import { Aspect as i } from "./index5.js";
const o = (t) => {
  if (!t)
    return !1;
  try {
    return new URL(t), !0;
  } catch {
    return !1;
  }
}, c = (t) => {
  if (!o(t))
    return;
  const n = new URL(t), e = new URLSearchParams(n.search), s = [
    e.get("x"),
    e.get("y"),
    e.get("width"),
    e.get("height")
  ];
  if (s.includes(null) || s.some((r) => r && isNaN(Number(r))))
    return;
  const a = e.get("aspect");
  if (!(!a || !Object.values(i).includes(a)))
    return {
      x: Number(e.get("x")),
      y: Number(e.get("y")),
      width: Number(e.get("width")) || 100,
      height: Number(e.get("height")) || 100,
      unit: "%",
      aspect: e.get("aspect") || i.CUSTOM
    };
}, u = (t, n, e) => {
  if (!t)
    return "";
  const s = new URL(t), a = `${s.origin}${s.pathname}`, r = new URLSearchParams(s.search);
  return r.set("x", n.x.toFixed(4)), r.set("y", n.y.toFixed(4)), r.set("height", n.height.toFixed(4)), r.set("width", n.width.toFixed(4)), r.set("aspect", e), `${a}?${r.toString()}`;
}, m = (t) => !!c(t), d = (t) => {
  if (!t)
    return t;
  const n = ["x", "y", "width", "height", "aspect"], e = new URL(t), s = `${e.origin}${e.pathname}`, a = new URLSearchParams(e.search);
  return n.forEach((r) => {
    a.get(r) && a.delete(r);
  }), a.size ? `${s}?${a.toString()}` : s;
};
export {
  m as isImageCropped,
  d as resetImageCrop,
  u as transformCropParamsToUrlParams,
  c as transformUrlParamsToCropParams
};
